module.exports = __webpack_public_path__ + "media/images/banner-a7380a867094f71b66c877fc74e2f7c5.jpg";